var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div uib-alert ng-repeat=\"alert in getAlerts()\" ng-class=\"'alert-' + (alert.type || 'info')\" dismiss-on-timeout=\"3500\" close=\"closeAlert($index)\">\n<small>{{ alert.msg }}</small>\n</div>\n";
var id1="partials/alert.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;